module.exports = __webpack_public_path__ + "static/media/server-secure-illustration.0af0a49c.svg";